import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Onboarding } from './Onboarding';
import { profileApi } from '../../../shared/api/profileApi';
import { useAuth } from '../../../shared/contexts/AuthContext';

export const OnboardingContainer: React.FC = () => {
    const navigate = useNavigate();
    const { checkSession } = useAuth();

    const handleOnboardingComplete = async () => {
        try {
            console.log('[Onboarding] Starting completion...');
            // Mark onboarding as complete in the database
            await profileApi.updateProfile({
                has_completed_onboarding: true,
                onboarding_completed_at: new Date()
            });
            console.log('[Onboarding] Profile updated, navigating to pricing...');
            
            // Update the session to get the latest profile
            await checkSession();
            
            // Navigate using React Router with state to bypass protected route check
            navigate('/pricing', { 
                replace: true,
                state: { hasCompletedOnboarding: true }
            });
            console.log('[Onboarding] Navigation called');
        } catch (error) {
            console.error('[Onboarding] Failed to complete onboarding:', error);
        }
    };

    return <Onboarding onComplete={handleOnboardingComplete} />;
}; 